module.exports = __webpack_public_path__ + "assets/montserrat-semibold.5f191717811a261db0c331ec1ba6e6aedb298fa3f873767d0f9aa4ea2864a1bc.woff2";